import { createFileRoute } from "@tanstack/react-router";
import { motion } from "framer-motion";
import "../css/Auth.css";
import "../css/Welcome.css";

export const Route = createFileRoute("/welcome/step-3")({
  component: WelcomeStep3,
});

function WelcomeStep3() {
  // Authentication temporarily disabled

  return (
    <div className="welcome-signup-page">
      <div className="welcome-signup-container">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="welcome-hero"
        >
          <h1 className="welcome-hero__title">
            Learn the Next Wave of Tech
          </h1>

        </motion.div>

        {/* Value Props */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="welcome-benefits"
        >
          <div className="welcome-benefit">
            <span className="welcome-benefit__icon">🚀</span>
            <div>
              <h3>Launch Your Own Products</h3>
              <p>
                Build SaaS apps, tools, and services that solve real problems
                and generate revenue
              </p>
            </div>
          </div>
          <div className="welcome-benefit">
            <span className="welcome-benefit__icon">🌍</span>
            <div>
              <h3>Work From Anywhere</h3>
              <p>
                Beach, mountain, coffee shop—your office is wherever you want it
                to be
              </p>
            </div>
          </div>
          <div className="welcome-benefit">
            <span className="welcome-benefit__icon">💰</span>
            <div>
              <h3>Future-proof Your Life</h3>
              <p>
                Join the builders and learners creating the future of Tech.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Signup CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="welcome-signup-box"
        >
          <h2>Start Your Journey Today</h2>
          <p>
            Join TechNYC to learn the skills that power indie hacker success
          </p>

          <div style={{
            padding: '2rem',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '12px',
            textAlign: 'center',
            margin: '1.5rem 0'
          }}>
            <p style={{ 
              fontSize: '1.1rem', 
              color: '#fff',
              margin: 0,
              opacity: 0.9
            }}>
              Authentication temporarily disabled
            </p>
          </div>

          <p className="welcome-signup-note">
            Free access to 10 courses and 50+ labs. Upgrade anytime for
            premium features.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
